import { SelectOption } from '@anytag/shared-types';
import { EngagementCampaignPostStatusForInsightCheck } from '@anytag/graphql';
import { useTranslateOptions } from './useTranslateOptions';

export const usePostsInsightStatusOptions = () => {
  const postsInsightStatusOptions: SelectOption<EngagementCampaignPostStatusForInsightCheck>[] = useTranslateOptions([
    { label: 'Confirmed', value: EngagementCampaignPostStatusForInsightCheck.CONFIRMED },
    { label: 'Unconfirmed', value: EngagementCampaignPostStatusForInsightCheck.UNCONFIRMED }
  ]);

  return { postsInsightStatusOptions };
};
